/**
 * Roles y permisos.
 *
 * Un solo mecanismo, a proposito. El sistema anterior tenia dos vias paralelas
 * (`autorizarRoles` y `requirePermission`) mas un arreglo `permissions` por
 * usuario que anulaba la matriz de roles; esa division produjo bugs reales de
 * autorizacion. Aqui la matriz es estatica y no hay override por usuario.
 */
export const ROLES = ['propietario', 'medico', 'asistente'];
export const PERMISOS = [
    // Organizacion y cuentas
    'organizacion:leer',
    'organizacion:editar',
    'usuarios:leer',
    'usuarios:administrar',
    // Pacientes y expediente
    'pacientes:leer',
    'pacientes:crear',
    'pacientes:editar',
    'pacientes:eliminar',
    'pacientes:remitir',
    'credenciales:revisar',
    'historia:leer',
    'historia:escribir',
    // Encuentros: la atencion clinica (F2.2). Recepcion agenda citas, no abre
    // encuentros: el motivo y el contexto ya son contenido clinico.
    'encuentros:leer',
    'encuentros:escribir',
    // Observaciones y mediciones (F2.3)
    'observaciones:leer',
    'observaciones:escribir',
    // Problemas, alergias y medicacion (F2.4). Recepcion no los lee ni los
    // edita: las alergias se copian a la receta (FIND-020).
    'antecedentes:leer',
    'antecedentes:escribir',
    // Colposcopías
    'colposcopias:leer',
    'colposcopias:crear',
    'colposcopias:editar',
    // Agenda
    'citas:leer',
    'citas:administrar',
    'agenda:configurar',
    // Documentos firmados
    'recetas:leer',
    'recetas:emitir',
    'notas:leer',
    'notas:escribir',
    // Plantillas de formulario y documento clinico generico (F2.6). Administrar
    // plantillas (publicar, retirar) es del propietario; usarlas, de quien atiende.
    'plantillas:leer',
    'plantillas:administrar',
    'documentos:leer',
    'documentos:escribir',
    'documentos:compartir',
    // Estudios (F3.4): leer, registrar y PUBLICAR son tres permisos. Publicar al
    // portal es una decision clinica aparte de que el resultado exista.
    'estudios:leer',
    'estudios:escribir',
    'estudios:publicar',
    // Planes de atencion (F4.5)
    'planes:leer',
    'planes:escribir',
    // Seguimiento (F4.7): ver la bandeja y revisar lo que registra la paciente
    'seguimiento:leer',
    'seguimiento:revisar',
    // Mensajeria (F4.8): lo clinico y lo administrativo son permisos distintos.
    // Recepcion atiende horarios; no lee sintomas, dieta ni tratamiento (§9.2).
    'mensajes:clinicos',
    'mensajes:administrativos',
    // Corregir o cancelar un documento firmado por OTRA persona (FIND-007). El
    // firmante no lo necesita para lo suyo.
    'documentos:supervisar',
    // Regulatorio
    'auditoria:leer',
    'expediente:exportar',
];
/**
 * Matriz de permisos por rol.
 *
 * - `propietario`: el medico dueno del consultorio. Manda dentro de SU
 *   organizacion y en ninguna otra. No existe un rol que vea todas las
 *   organizaciones.
 * - `medico`: ejerce clinicamente y firma, pero no administra la cuenta.
 * - `asistente`: recepcion. Agenda y datos administrativos del paciente;
 *   no lee ni escribe contenido clinico, y no firma nada.
 */
export const PERMISOS_POR_ROL = {
    propietario: PERMISOS,
    medico: [
        'organizacion:leer',
        'usuarios:leer',
        'pacientes:leer',
        'pacientes:crear',
        'pacientes:editar',
        'pacientes:remitir',
        'historia:leer',
        'historia:escribir',
        'encuentros:leer',
        'encuentros:escribir',
        'observaciones:leer',
        'observaciones:escribir',
        'antecedentes:leer',
        'antecedentes:escribir',
        'colposcopias:leer',
        'colposcopias:crear',
        'colposcopias:editar',
        'citas:leer',
        'citas:administrar',
        'recetas:leer',
        'recetas:emitir',
        'notas:leer',
        'notas:escribir',
        'plantillas:leer',
        'documentos:leer',
        'documentos:escribir',
        'documentos:compartir',
        'estudios:leer',
        'estudios:escribir',
        'estudios:publicar',
        'planes:leer',
        'planes:escribir',
        'seguimiento:leer',
        'seguimiento:revisar',
        'mensajes:clinicos',
        'mensajes:administrativos',
        'auditoria:leer',
        'expediente:exportar',
    ],
    asistente: [
        'organizacion:leer',
        'pacientes:leer',
        'pacientes:crear',
        'pacientes:editar',
        'citas:leer',
        'citas:administrar',
        'mensajes:administrativos',
    ],
};
export function rolTienePermiso(rol, permiso) {
    return PERMISOS_POR_ROL[rol].includes(permiso);
}
//# sourceMappingURL=acceso.js.map